import SphDialog from './Dialog.vue';

export { SphDialog };
export default SphDialog;
